import { Box, Button, Divider, Typography } from "@material-ui/core";
import React, { useState, useCallback, useEffect, useRef } from "react";
import StickyHeadTable from "src/components/CommonComponents/Table";
import { useDispatch, useSelector } from "react-redux";
import { householdResilienceListAction } from "src/Redux/Actions/HouseholdResilienceAction";
import moment from "moment";
import { purposeListAction } from "src/Redux/Actions/PurposeAction";
import LoadingBox from "src/components/LoadingBox";
import { fetchWrapper } from "src/services/http_requests";
import { stateListAction } from "src/Redux/Actions/StateAction";
import { generateSerialNo } from "src/utils";
import theme from "src/theme";
import { ArrowRightAlt, CloudDownload, FilterList, VisibilityOutlined } from "@material-ui/icons";
import { ngoListAction } from "src/Redux/Actions/NgoAction";
import DialogView from "src/components/CommonComponents/DialogView";
import CommonFilter2 from "src/components/CommonComponents/CommonFilter2";
import ResilienceViewForm from "./ResilienceViewForm";
import { isEqual } from "lodash";
import { loadData } from "src/utils/sessionStorage";
import { toast } from "react-toastify";
import { paramsUrl } from "src/utils/halper";
import { useNavigate } from "react-router-dom";

const columns = [
  { id: "sno", label: "S.No" },
  { id: "fo", label: "FO" },
  { id: "sakhiName", label: "Sakhi Name" },
  { id: "beneficiary", label: "Beneficiary" },
  // { id: "hhId", label: "HH ID" },
  { id: "mappingDate", label: "Mapping Date" },
  { id: "savings", label: "Savings" },
  { id: "investment", label: "Investment" },
  { id: "insurance", label: "Insurance" },
  { id: "loan", label: "Loan" },
  { id: "pension", label: "Pension" },
  { id: "initialResilienceScore", label: "Initial Resilience Score" },
  { id: "resilienceScore", label: "Updated Resilience Score" },
  { id: "action", label: "Action" },
];

function createData(
  sno,
  fo,
  sakhiName,
  beneficiary,
  // hhId,
  mappingDate,
  savings,
  investment,
  insurance,
  loan,
  pension,
  initialResilienceScore,
  resilienceScore,
  action
) {
  return {
    sno,
    fo,
    sakhiName,
    beneficiary,
    // hhId,
    mappingDate,
    savings,
    investment,
    insurance,
    loan,
    pension,
    initialResilienceScore,
    resilienceScore,
    action,
  };
}

function HouseholdResilienceMapping() {
  const userInfo = loadData("loginInfo");
  const token = userInfo?.token;
  const Base_Url = process.env.REACT_APP_API_URL;
  const navigate = useNavigate();

  const pageInfo = localStorage.getItem("pageInfo");
  const loginInfo = JSON.parse(localStorage.getItem("loginInfo")) || {};
  const loginUserRole = loginInfo?.data?.role_id;

  const [openView, setOpenView] = useState(false);
  const [crudAction, setCrudAction] = useState({
    create: false,
    edit: false,
    view: false,
    delete: false,
  });
  const [paramsId, setParamsId] = useState(null);
  const [filterData, setFilterData] = useState({
    village_id: [],
    block_id: [],
    district_id: [],
    state_id: "",
    resilient_color: "",
    household_id: "",
    // beneficiary_id: null,
    beneficiary_name: "",
    beneficiary_mobile: null,
    from: "",
    to: "", 
    sakhi_id: null,
    // sakhi_name: "",
    ngo_id: null,
    fo_id: null,
  });
  const [showFilter, setShowFilter] = useState(false);
  const { states } = useSelector((state) => state.statesList);
  const { purposes } = useSelector((state) => state.purposeList);
  const { loading, householdResilience } = useSelector((state) => state.householdResilienceList);

  const [total, setTotal] = useState(0);
  const [page, setPage] = useState(() => pageInfo ? parseInt(pageInfo) : 1);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [isMounted, setIsMounted] = useState(true);

  const dispatch = useDispatch();

  const getResilienceScore = (resilient_color) => {
    if(resilient_color === "red") {
      return "low"
    } else if(resilient_color === "amber") {
      return "medium"
    } else if(resilient_color === "green") {
      return "high"
    } else {
      return ""
    }
  }

  const getHouseholdResilienceApiPayloads = () => {
    return {
      village_id: Array.isArray(filterData?.village_id) ? filterData?.village_id?.join(",") : filterData?.village_id || "",
      block_id: Array.isArray(filterData?.block_id) ? filterData?.block_id?.join(",") : filterData?.block_id || "",
      district_id: Array.isArray(filterData?.district_id) ? filterData?.district_id?.join(",") : filterData?.district_id || "",
      state_id: filterData?.state_id || "",
      score: getResilienceScore(filterData?.resilient_color) || "",
      household_id: filterData?.household_id || "",
      // beneficiary_id: filterData?.beneficiary_id,
      beneficiary_name: filterData?.beneficiary_name || "",
      beneficiary_mobile: filterData?.beneficiary_mobile || "",
      from: filterData?.from ? moment(filterData.from).format("YYYY-MM-DD") : "",
      to: filterData?.to ? moment(filterData.to).format("YYYY-MM-DD") : "",
      sakhi_id: filterData?.sakhi_id || null,
      // sakhi_name: filterData?.sakhi_name,
      ngo_id: filterData?.ngo_id || null,
      fo_id: filterData?.fo_id || null,
      page: page,
      limit: rowsPerPage,
    }
  }

  const handleFilterSearch = useCallback(() => {
    if (page === 1) {
      dispatch(
        householdResilienceListAction(getHouseholdResilienceApiPayloads())
      );
    } else {
      localStorage.setItem("pageInfo", 1);
      setPage(1);
    }
  }, [dispatch, filterData, page, setPage]);
  
  const handleRestFilter = useCallback(() => {
    setFilterData({
      village_id: [],
      block_id: [],
      district_id: [],
      state_id: "",
      resilient_color: "",
      household_id: "",
      // beneficiary_id: null,
      beneficiary_name: "",
      beneficiary_mobile: null,
      from: "",
      to: "",
      sakhi_id: null,
      // sakhi_name: "",
      ngo_id: null,
      fo_id: null,
    });
    if (page === 1) {
      dispatch(householdResilienceListAction({ page, limit: rowsPerPage }));
    } else {
      localStorage.setItem("pageInfo", 1);
      setPage(1);
    }
  }, [dispatch, page, setPage]);

  // Initial data fetch - ensure this runs on component mount
  useEffect(() => {
    let mounted = true;
    if (mounted) {
      // Always fetch household resilience data on mount
      // dispatch(householdResilienceListAction({ page: page || 1, limit: rowsPerPage }));
      
      if (purposes === undefined || purposes === null) {
        dispatch(purposeListAction({ fetched: "All" }));
      }
      if (states === undefined || states === null) {
        dispatch(stateListAction({ fetched: "All" }));
      }
      if (loginUserRole === 1) {
        dispatch(ngoListAction({ fetched: 'All' }));
      }
    }
    window.scrollTo(0, 0);
    
    return () => {
      mounted = false;
      setIsMounted(false);
      fetchWrapper?.finishPendingRequests();
    };
  }, [dispatch, loginUserRole]);

  // Update total count when data changes
  useEffect(() => {
    if (!isMounted) return;
    
    if (householdResilience?.total) {
      setTotal(householdResilience?.total);
      localStorage.setItem("totalData", householdResilience?.total);
    } else if (parseInt(page) === 1 && householdResilience?.data?.length) {
      setTotal(householdResilience?.data?.length);
      localStorage.setItem("totalData", householdResilience?.data?.length);
    } else {
      setTotal(localStorage.getItem("totalData") || 0);
    }
  }, [householdResilience, page, isMounted]);

  // Fetch data when page or filters change
  useEffect(() => {
    if (!isMounted || !page) return;
    
    const controller = new AbortController();
    
    dispatch(
      householdResilienceListAction(getHouseholdResilienceApiPayloads())
    );
    
    return () => {
      controller.abort();
    };
  }, [
    dispatch, 
    page, 
    // filterData,
    isMounted
  ]);

  // Create rows for table display with safety checks
  const rows = React.useMemo(() => {
    if (!householdResilience?.data || householdResilience.data.length === 0) {
      return [];
    }
    
    return householdResilience.data.map((item, i) => {
      return createData(
        generateSerialNo(i, page),
        item?.fo?.name || "FO Name",
        item?.sakhi?.name || "Sakhi Name", 
        item?.beneficiary?.name || "Beneficiary Name",
        // item?.household_id || "HH ID",
        item?.created_at ? moment(item?.created_at).format("DD/MM/YYYY") : "",
        item?.savings?.option ? (item.savings.option.length > 1 || (item.savings.option.length === 1 && item.savings.option[0] !== 9999) ? "Yes" : "No") : "No",
        item?.investment?.option ? (item.investment.option.length > 1 || (item.investment.option.length === 1 && item.investment.option[0] !== 9999) ? "Yes" : "No") : "No",
        item?.insurance?.option ? (item.insurance.option.length > 1 || (item.insurance.option.length === 1 && item.insurance.option[0] !== 9999) ? "Yes" : "No") : "No",
        item?.loan?.option ? (item.loan.option.length > 1 || (item.loan.option.length === 1 && item.loan.option[0] !== 9999) ? "Yes" : "No") : "No", 
        item?.pension?.option ? (item.pension.option.length > 1 || (item.pension.option.length === 1 && item.pension.option[0] !== 9999) ? "Yes" : "No") : "No",
        item?.initial_score || 0,
        item?.score || item?.resilience_score || 0,
        <Box className="space-x-3">
          <button
            className="cursor-pointer"
            onClick={() => {
              setParamsId(item?.household_id);
              setCrudAction({
                create: false,
                edit: false,
                view: true,
                delete: false,
              });
              setOpenView(true);
            }}
          >
            <VisibilityOutlined color="primary" />
          </button>
        </Box>
      );
    });
  }, [householdResilience?.data, page]);

  const refetchUserList = useCallback(() => {
    const filters = {
      ...filterData, 
      page: pageInfo,
      limit: rowsPerPage,
      from_date: filterData.from ? moment(filterData.from).format("YYYY-MM-DD") : "",
      to_date: filterData.to ? moment(filterData.to).format("YYYY-MM-DD") : "",
    };
    dispatch(householdResilienceListAction(filters));
    setOpenView(false);
  }, [dispatch, filterData, pageInfo]);

  const prevCsvQuery = useRef({});
  const getCsvDownloadData = async (query) => {
    const filter = {
      token: token,
      type: "household_resilience",
      ...getHouseholdResilienceApiPayloads()
    };
    delete filter.page;

    if (isEqual(prevCsvQuery.current || {}, filter)) {
      toast.error("A download request with same filter is already executed")
      return;
    }
    prevCsvQuery.current = filter;
    const url = `${Base_Url}/download_sheet/request${paramsUrl(filter)}`;
    try {
      const data = await fetchWrapper.get(url, { responseType: "arraybuffer" });
      if (data.success) toast.success(data.message || "Download request is in the queue.");
    } catch (error) {
      toast.error(error);
    }
  };

  const filtersToDisplay = [
    "state_id", "district_id", "block_id","village_id", "from", "to", "fo_id", "sakhi_id", "resilient_color", "household_id", "beneficiary_name", "beneficiary_mobile",
  ];

  return (
    <Box className="w-full min-h-screen bg-gray-100 pl-4 pr-5 md:px-4 py-24 sm:py-10">
      <Box width="100%" height="100%">
        <Box
          pb={2}
          width="100%"
          display="flex"
          flexDirection="row"
          justifyContent="space-between"
        >
          <Typography>
            <span className="capitalize font-semibold text-md md:text-lg lg:text-xl text-black">
              Household Resilience Mapping
            </span>
          </Typography>
          <Box className="space-x-2">
            <Button
              variant="contained"
              size="small"
              startIcon={<FilterList color="primary" />}
              onClick={() => setShowFilter(!showFilter)}
              style={{
                backgroundColor: "white",
                color: theme.palette.primary.main,
              }}
            >
              Filter
            </Button>
            <Button
              variant="contained"
              size="small"
              endIcon={<CloudDownload />}
              onClick={() => getCsvDownloadData()}
              color="primary"
            >
              Download CSV
            </Button>
            <Button
              variant="contained"
              size="small"
              endIcon={<ArrowRightAlt />}
              onClick={() => navigate('/app/download-queue-list?reportType=household_resilience')}
              style={{
                backgroundColor: "white",
                color: theme.palette.primary.main,
              }}
            >
              Download Status
            </Button>
          </Box>
        </Box>
        <Divider style={{ maxWidth: "100%" }} />
        {showFilter ? (
          <CommonFilter2
            filterData={filterData}
            showFilter={showFilter}
            setFilterData={setFilterData}
            handleFilterSearch={handleFilterSearch}
            handleRestFilter={handleRestFilter}
            filtersToDisplay={loginUserRole === 1 ? [...filtersToDisplay, "ngo_id"] : filtersToDisplay}
            parentComponent="householdResilienceMapping"
          />
        ) : null}
        {loading ? (
          <LoadingBox type={showFilter ? 'table' : ""} />
        ) : (
          <StickyHeadTable
            columns={columns}
            rows={rows}
            loading={loading}
            total={total}
            page={page}
            setPage={setPage}
            rowsPerPage={rowsPerPage}
            setRowsPerPage={setRowsPerPage}
          />
        )}
      </Box>
      <DialogView 
        openView={openView} 
        handleCloseView={() => setOpenView(false)}
        title={`${crudAction.view ? "View" : 'Update'} Resilience Details`}
        classes={{ paper: "dialog-paper" }}
      >
        <ResilienceViewForm
          resilienceDetails={householdResilience?.data?.find(item => item?.household_id === paramsId)}
          crudAction={crudAction} 
          refetchUserList={refetchUserList} 
        />
      </DialogView>
    </Box>
  );
}

export default HouseholdResilienceMapping;
